import Block from "quill/blots/block";

export class DivBlot extends Block {
  static blotName = "block-div";
  static tagName = "div";

  static create(value) {
    const node = super.create();
    const id = value && typeof value === "object" ? value.id : undefined;
    if (id) {
      node.setAttribute("id", id);
    }
    return node;
  }

  static formats(domNode) {
    return {
      id: domNode.getAttribute("id"),
    };
  }
}
